const apiUrl = process.env.REACT_APP_API || 'http://localhost:3030'

const apiPageLimit = process.env.REACT_APP_DEFAULT_PAGE_LIMIT || 100

//set to 1 and 6 to have last week up to yesterday
const reportEndDateDiff = process.env.REACT_APP_DEFAULT_END_DATE_DIFF || 0
const reportStartDateDiff =process.env.REACT_APP_DEFAULT_START_DATE_DIFF || 7

const clusterApi = process.env.REACT_APP_CLUSTER_API || 'http://localhost:8001'

//export default apiUrl;
export {apiUrl, apiPageLimit, reportEndDateDiff, reportStartDateDiff, clusterApi}